export enum AccessEnum {
  VIEW = "view",
  EDIT = "edit",
  DELETE = "delete",
}
